import { DeviceAddressBooks } from '@/types/address-book';

export type AddressBookDrift = {
  /** Distinct address-book ids across all devices that have a book assigned. */
  distinctIds: Set<string>;
  /** True when devices in the same unit point at more than one address book. */
  driftDetected: boolean;
};

/**
 * Every device in a unit should normally share the same address book. Collect
 * the distinct address-book ids across all devices that actually have a book
 * (devices with no book contribute nothing — that state is surfaced separately
 * per device). More than one distinct id means the unit has drifted.
 */
export const computeAddressBookDrift = (
  devices: DeviceAddressBooks[],
): AddressBookDrift => {
  const distinctIds = new Set<string>();
  for (const device of devices) {
    for (const book of device.addressBooks) {
      distinctIds.add(book.addressBookId);
    }
  }
  return { distinctIds, driftDetected: distinctIds.size > 1 };
};
